export function getCalendarDate(value: string | null | undefined): string {
  return value?.slice(0, 10) ?? '';
}

export function filterByCalendarDate<T>(
  items: T[],
  selectedDate: string | null,
  getDate: (item: T) => string | null | undefined
): T[] {
  if (!selectedDate) return items;
  return items.filter((item) => getCalendarDate(getDate(item)) === selectedDate);
}

export function formatCalendarDate(date: string): string {
  return new Date(`${date}T00:00:00`).toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
